module.exports = __webpack_public_path__ + "static/images/components/ButtonLeavingClan/images/button-exit-clan.dba9d05d.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonLeavingClan/images/button-exit-clan.png
// module id = 2571
// module chunks = 11